export enum MontlyMisColumn{
    DISPATCHED_QTY = 'DISPATCHED QUANTITY',
    LOCAL_SALE_QTY = 'LOCAL SALE QUANTITY',
    LAB_COMPLIMENTS_QTY = 'LAB COMPLIMENTS QUANTITY',
    FRESH_PRODUCTION_QTY = 'FRESH PRODUCTION QUANTITY',
    RE_PROCESS_QTY = 'REPROCESS QUANTITY',
    RECEIVED_RM_PURCHASE_QTY = 'RECEIVED RM PURCHASE QUANTITY',
    PROCURED_RM_PURCHASE_QTY = 'PROCURED RM PURCHASE QUANTITY',
    LOSS_OR_GAIN_QTY = 'LOSS OR GAIN QTY',
    RM_AVG_PRICE = 'RM AVG PRICE',
    HON_FG_QTY = 'HON FG QTY',
    FG_PURCHASE_QTY = 'FG PURCHASE QTY',
    TRANSFER_QTY = 'TRANSFER QTY',
    HON_TO_FG_YILED = 'HON TO FG YIELD',
    HON_TO_HL_YIELD = 'HON TO HL YIELD',
    SHIPPED_CONTAINERS = 'SHIPPED CONTAINERS',
    EXPORTS_SALES_AMOUNT = 'EXPORTS SALES AMOUNT',
    EXPORTS_SALE_AMOUNT_KG = 'EXPORTS SALES AMOUNT KG',
    DOMESTIC_SALE_AMOUNT = 'DOMESTIC SALE AMOUNT',
    DOMESTIC_SALE_AMOUNT_KG = 'DOMESTIC SALE AMOUNT_KG',
    SALE_RETURN = 'SALE RETUEN',
    RM_COST = 'RM COST',
    RM_COST_KG = 'RM COST KG',
    PRODUCT_PURCHASE_COST = 'PRODUCT PURCHASE COST',
    PRODUCT_PURCHASE_COST_KG = 'PRODUCT PURCHASE COST_KG',
    PACK_MATERIAL_COST = 'PACK MATERIAL COST',
    PACK_MATERIAL_COST_KG = 'PACK MATERIAL COST KG',
    SALE_CHEM_PACK_COST = 'SALET CHEM PACK COST',
    SALE_CHEM_PACK_COST_KG = 'SALET CHEM PACK COST KG',
    QC_COST = 'QC COST',
    QC_COST_KG = 'QC COST KG',
    CONSUMABLE_COST = 'CONSUMABLE COST',
    CONSUMABLE_COST_KG = 'CONSUMABLE COST KG',
    BOILER_FUEL_COST = 'BOILER FUEL COST',
    BOILER_FUEL_COST_KG = 'BOILER FUEL COST KG',
    MAINTAINANCE_COST = 'MAINTAINANCE COST',
    MAINTAINANCE_COST_KG = 'MAINTAINANCE COST KG',
    EXTERNAL_COLD_STORAGE_COST = 'EXTERNAL COLD STORAGE COST',
    EXTERNAL_COLD_STORAGE_COST_KG = 'EXTERNAL COLD STORAGE COST KG'
}